import { SecureRoute } from '@okta/okta-react';
import React, { useMemo } from 'react';
import { RouteProps } from 'react-router';
import { PageLoading } from 'components/atoms/loading';
import { RoutePaths } from 'constant';
import { useFieldsLoaded } from 'hooks/use-fields-loaded';

const routesDependentOnFieldsStore = [
  RoutePaths.home, // this is added because notifications is dependant on some fields
  RoutePaths.projects, // this is added as we need to check phase status to show collapsed mode
  RoutePaths.projectDetail, // for customer route; as RoutePaths.project does not cover ProjectDependentRoutes
  // any more routes dependant on fieldsStore should be added here
];

export const CustomSecureRoute = (props: RouteProps): React.ReactElement => {
  const { path: originalPath } = props;
  const { isFieldsLoaded } = useFieldsLoaded();

  /**
   * below double check is because by default, path can be string | string[] | undefined
   */
  const path = Array.isArray(originalPath)
    ? originalPath[0]
    : originalPath ?? '';

  const isRouteDependantOnFields = useMemo(
    () => routesDependentOnFieldsStore.includes(path),
    [path],
  );

  return isRouteDependantOnFields && !isFieldsLoaded ? (
    <PageLoading css />
  ) : (
    <SecureRoute {...props} />
  );
};
